var api = require('api')

module.exports = {
  uploadFile: function (file, next, err) {
    var formData = new FormData()
    formData.append('file', file)

    api.$http.post(api.$host + '/file', formData).then(next, err)
  },
  // remove: function (s3Key, next, err) {
  //   api.File.remove({
  //     key: s3Key
  //   }).then(next, err)
  // },
  remove: function (s3Key, id, next, err) {
    console.log('remove: ' + id)
    api.File.remove({
      key: s3Key,
      id: id
    }).then(next, err)
  }
}



// WEBPACK FOOTER //
// ./src/api/File.js